/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Card, CardBody } from '@components/card/card';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { Link, useNavigate } from 'react-router-dom';
// import ModalComponent from '@components/Modal/ModalComponent';
import {
  deleteEquipmentsWorkOrder,
  GetEquipmentsWorkOrderList
} from '@store/FLEET/EquipmentsWorkOrder/equipmentsworkorderSlice';
import { GetFleetRequestType } from '@store/Lookup/lookupSlice';
import NtxTable from '@components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';
import ViewWorkOrder from './ViewOrder';
import WorkRequestList from './WorkRequestList';
import NeatixModal from '@components/Modal/NeatixModal';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import confirmAction from '@components/Shared/Alert/confirmAction';
import type { APIResponse } from '@store/Shared/shared';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import ListPrint from '@components/Print/ListPrint';

const Index = () => {
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [id, setId] = useState('');
  const [Item, setItem] = useState<any>();

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(GetEquipmentsWorkOrderList());
    dispatch(GetFleetRequestType());
  }, []);
  const { EquipmentsWorkOrderList, loading, error } = useAppSelector(state => state.EquipmentsWorkOrder);

  //________________________________

  const columns = [
    { title: t('OrderNumber'), key: 'OrderNumber' },
    { title: t('Vehicle'), key: 'Equipment' },
    { title: t('Date'), key: 'date' },
    { title: t('InternalOrExternal'), key: 'InternalOrExternal', sortValue: (row: any) => row.internalStatus },
    {
      title: t('statusAndEndDate'),
      key: 'statusAndEndDate',
      className: '',
      sortValue: (row: any) => {
        // إذا كان مغلق نستخدم تاريخ الإغلاق، وإذا كان مفتوح نضعه 0 ليأتي في النهاية
        return row.dateCompletion ? new Date(row.dateCompletion).getTime() : 0;
      }
    },
    { title: t('isConfrimStatus'), key: 'isConfrim', className: '', sortValue: (row: any) => (row.isConfirm ? 1 : 0) },
    {
      title: t('inventoryStatus'),
      key: 'inventoryStatus',
      className: '',
      sortValue: (row: any) => (row.inventoryFlag ? 1 : 0)
    },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = EquipmentsWorkOrderList?.slice()
    // ?.sort((a, b) => {
    //   const dateA = new Date(a.startDateSugg);
    //   const dateB = new Date(b.startDateSugg);

    //   return dateB.getTime() - dateA.getTime(); // تصاعدي (الأقدم -> الأحدث)
    // })
    ?.sort((a, b) => {
      // الفرز تصاعديًا حسب orderCode (من الأصغر للأكبر)
      // إذا أردت تنازليًا (من الأكبر للأصغر) اعكس الطرح
      // return a.orderCode.localeCompare(b.orderCode, undefined, { numeric: true });
      return b.orderCode.localeCompare(a.orderCode, undefined, { numeric: true });
    })
    ?.map(item => {
      let rowClass;

      const statusText = item?.dateCompletion === null ? t('Open') : t('Closed');
      const statusClass = item?.dateCompletion === null ? 'badge bg-warning text-dark' : 'badge bg-success text-white';
      const endDate = item?.dateCompletion ? new Date(item.dateCompletion).toLocaleDateString(i18n.language) : '';

      return {
        date: item.startDateSugg?.split('T')[0],
        OrderNumber: item?.orderCode,
        Equipment: i18n.language === 'ar' ? item?.fleetEquipmentsName2 : item?.fleetEquipmentsName,
        TypeMaintenance: i18n.language === 'ar' ? item.requestTypeName2 : item.requestTypeName,
        endDate: item?.dateCompletion?.split('T')[0] ?? '',

        dateCompletion: item?.dateCompletion, // مهم للفرز بـ statusAndEndDate
        isConfirm: item.isConfirm, // مهم للفرز بـ isConfrimStatus
        inventoryFlag: item.inventoryFlag, // مهم للفرز بـ inventoryStatus
        internalStatus: item.isInternal ? true : false, // قيمة  للفرز

        statusAndEndDate: endDate ? (
          <>
            <span className={statusClass}>{statusText}</span> - {endDate}
          </>
        ) : (
          <span className={statusClass}>{statusText}</span>
        ),

        InternalOrExternal: (
          <span
            className={`badge ${
              item.isInternal ? 'bg-info' : 'bg-secondary'
            } text-white px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center`}
          >
            <i className={`fa ${item.isInternal ? 'fa-home' : 'fa-store'} fs-15px fa-fw me-5px`}></i>
            {item.isInternal === true
              ? i18n.language === 'ar'
                ? 'داخلي'
                : 'Internal'
              : i18n.language === 'ar'
              ? 'خارجي'
              : 'External'}
          </span>
        ),

        SupplierOrWorkshop:
          item.isInternal === true
            ? i18n.language === 'ar'
              ? item.workshopName2
              : item.workshopName
            : i18n.language === 'ar'
            ? item.supplierName2
            : item.supplierName,
        isConfrim: item.isConfirm ? (
          <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
            <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
            {t('Confirmed')}
          </span>
        ) : (
          <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
            <i className='fa fa-times-circle fs-15px fa-fw me-5px'></i>
            {t('NotConfirmed')}
          </span>
        ),

        inventoryStatus: item.inventoryFlag ? (
          <span className=' badge border border-success  text-success  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center '>
            <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
            {t('Delivered')}
          </span>
        ) : (
          <span className=' badge border border-danger  text-danger  px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center '>
            <i className='fa fa-times-circle fs-15px fa-fw me-5px'></i>
            {t('NotDelivered')}
          </span>
        ),

        action: (
          <>
            {HasPermission('FleetViewDetailsMaintenanceOrder') && (
              <button
                // hidden={item.isConfirm !== true || item.inventoryFlag !== true}
                type='button'
                className='btn btn-sm btn-outline-primary mx-1'
                onClick={() => {
                  setId(item.id);
                  setShow2(true);
                }}
                // data-bs-toggle='modal'
                // data-bs-target='#ModalCloseOrder'
              >
                <i className='far fa-lg fa-fw fa-eye'></i>
              </button>
            )}

            {/* {HasPermission('FleetCloseMaintenanceOrder') && (
              <button
                hidden={item.isConfirm !== true || item.inventoryFlag !== true}
                type='button'
                className='btn btn-sm btn-outline-theme me-2'
                onClick={() => setId(item.id)}
                data-bs-toggle='modal'
                data-bs-target='#ModalCloseOrder'
              >
                <i className='fa-lg fa-fw me-2 bi bi-check-circle-fill'></i>
                {t('Close_Maintenance_Order')}
              </button>
            )} */}

            {HasPermission('FleetEditMaintenanceOrder') && item.dateCompletion === null && (
              <button
                type='button'
                className='btn btn-sm btn-outline-theme me-1'
                onClick={() => Navigate(`UpdateWorkOrder/${item.id}`)}
              >
                <i className='far fa-lg fa-fw fa-edit'></i>
              </button>
            )}

            {HasPermission('FleetEditMaintenanceOrder') && item.dateCompletion === null && item.isConfirm !== true && (
              <button type='button' className='btn btn-sm btn-outline-danger' onClick={() => handleDelete(item.id)}>
                <i className='far fa-lg fa-fw fa-trash-alt'></i>
              </button>
            )}

            <button
              type='button'
              className='btn btn-sm btn-outline-secondary me-1'
              onClick={() => {
                setItem(item);
                setShow3(true);
              }}
            >
              <i className='fas fa-lg fa-fw fa-print'></i>
            </button>
          </>
        ),

        rowClass // استخدم rowClass هنا   onClick={() => handleDelete(item.id)}
      };
    });

  const handleDelete = async (Id: string) => {
    try {
      const IsConfirm = await confirmAction(t('MsgConfirm'));
      if (!IsConfirm) return; // Exit if user cancels

      const res = await dispatch(deleteEquipmentsWorkOrder(Id));

      const payload = res.payload as APIResponse<boolean>;

      if (payload.succeeded && payload.data) {
        CustomAlert({ action: 'Delete' });
        dispatch(GetEquipmentsWorkOrderList());
      } else {
        CustomAlert({ action: 'Error' });
      }

      // debugger;

      // CustomAlert({ action: 'Add' });
    } catch (error) {
      CustomAlert({ action: 'Error' });
      console.log(error);
      // CustomAlert({ action: 'Error' });
    }
  };
  //________________________________
  const isRTL = i18n.language === 'ar';

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'MaintenanceOrders',
              link: null
            }
          ]}
          PageName='MaintenanceOrders'
        />

        <div className={`ms-auto`}>
          <div
            hidden={
              !HasPermission('FleetAddDirectMaintenanceOrder') ||
              !HasPermission('FleetAddMaintenanceOrderFromMaintenanceRequest')
            }
            className='btn-group'
            role='group'
            dir={isRTL ? 'rtl' : 'ltr'}
          >
            <button
              type='button'
              className='btn btn-theme dropdown-toggle'
              data-bs-toggle='dropdown'
              aria-expanded='false'
              aria-label={t('NewMaintenanceOrder')}
              title={t('NewMaintenanceOrderTooltip')}
            >
              {t('NewMaintenanceOrder')}
            </button>

            <ul
              className={`dropdown-menu ${isRTL ? 'dropdown-menu-end' : 'dropdown-menu-start'}`}
              style={{ textAlign: isRTL ? 'right' : 'left' }}
            >
              {HasPermission('FleetAddDirectMaintenanceOrder') && (
                <li>
                  <Link className='dropdown-item d-flex align-items-center' to='AddWorkOrder'>
                    <i className={`bi bi-lightning fa-lg ${isRTL ? 'ms-2' : 'me-2'} text-theme`} aria-hidden='true' />
                    {t('DirectMaintenanceOrder')}
                  </Link>
                </li>
              )}

              {HasPermission('FleetAddMaintenanceOrderFromMaintenanceRequest') && (
                <li>
                  <Link className='dropdown-item d-flex align-items-center' to='' onClick={() => setShow(true)}>
                    <i className={`bi bi-list-check fa-lg ${isRTL ? 'ms-2' : 'me-2'} text-theme`} aria-hidden='true' />
                    {t('MaintenanceOrderFromRequest')}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      {/* <ModalComponent title={t('Close_Maintenance_Order')} id='ModalCloseOrder'>
        {id && <ViewWorkOrder Id={id} />}
      </ModalComponent> */}

      <NeatixModal show={show} setShow={setShow} bodyClassName='p-0' size='lg' showHeader={false}>
        <WorkRequestList />
      </NeatixModal>

      <NeatixModal show={show2} setShow={setShow2} size='xl' showHeader={false}>
        {id && <ViewWorkOrder Id={id} onClose={() => setShow2(false)} />}
      </NeatixModal>

      <style>{`
      .dropdown-toggle::after {
      margin-right: 10px;
      }
      `}</style>

      <NeatixModal show={show3} setShow={setShow3} size='sm' showHeader={false} centered bodyClassName='p-0'>
        <Card>
          <CardBody>
            {Item && (
              <>
                <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>{Item?.orderCode}</div>
                <ListPrint ReferenceId={Item.id} PrintTemplateTypeId='' />
              </>
            )}
            <button
              type='button'
              className='btn btn-lg btn-default rounded-1 w-100 mt-3'
              onClick={() => setShow3(false)}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </CardBody>
        </Card>
      </NeatixModal>
    </>
  );
};

export default Index;
